

import swal from "sweetalert";
import defaultSuccessIcon from "../../../assets/successIcon.png";
export default async function DisplayError({
  icon,
  title,
  id,
  path,
  historyHook,
  timer,
}) {
  console.log("🚀 ~ timer:", timer);
  // const erreurMessage = "Une erreur est survenue ,veuillez réessayer";
  const erreurMessage = "Une erreur est survenue ,veuillez réessayer ";
  const linkToDetails = path + id;
  function redirect() {
    historyHook.replace(linkToDetails);
  }

  const value = await swal({
    title: title ? title : erreurMessage,

    buttons: path
      ? {
          catch: {
            value: "visit",
          },
          cancel: "Fermer",
        }
      : { cancel: "Fermer" },
    icon: icon ? icon : defaultSuccessIcon,
    timer: timer ? timer : 10000,
    dangerMode: true,
  });
  switch (value) {
    case "visit":
      redirect();
      break;

    default:
      swal.close();
  }
}
